import { APICLIENT } from "../shared";
import { apiendpoints } from "../constants/api-endpoints";

  export const getAllTraders = async (pageNumber=1, pageSize=1000) => {
    try {
      const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
      const response = await axioClient.get(
        `${apiendpoints.GET_TRADERS}?pageNumber=${pageNumber}&pageSize=${pageSize}`
      );
      return APICLIENT.handleResponse(response);
    } catch (err) {
      return APICLIENT.handleError(err);
    }
  };

  export const getTraderById = async (businessId) => {
    try {
      const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
      const response = await axioClient.get(
        `${apiendpoints.GET_ORGANIZER_BY_ID}?businessId=${businessId}`
      );
      return APICLIENT.handleResponse(response);
    } catch (err) {
      return APICLIENT.handleError(err);
    }
  };


  export const updateProfile = async (data) => {
    try {
      const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
      const response = await axioClient.post(apiendpoints.UPDATE_ORGANIZER, data);
      const res = APICLIENT.handleResponse(response);
      return res;
    } catch (err) {
      return APICLIENT.handleError(err);
    }
  };

  export const handleProfileApproval = async (data) => {
    try {
      const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
      const response = await axioClient.post(apiendpoints.PROFILE_APPROVAL, data);
      const res = APICLIENT.handleResponse(response);
      return res;
    } catch (err) {
      return APICLIENT.handleError(err);
    }
  };
